import React from 'react';
import { TrendingDown } from 'lucide-react';

/**
 * Компонент настроек инфляции
 */
const InflationSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className={`p-4 rounded-lg border ${formData.includeInflation ? 'bg-rose-50 dark:bg-rose-900/20 border-rose-100 dark:border-rose-800' : 'bg-gray-50 dark:bg-gray-800/50 border-gray-200 dark:border-gray-700'}`}>
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-base font-medium text-gray-900 dark:text-white flex items-center">
          <TrendingDown className="w-5 h-5 mr-2 text-rose-500" />
          Инфляция
        </h3>
        <label className="inline-flex items-center">
          <input
            type="checkbox"
            name="includeInflation"
            checked={formData.includeInflation}
            onChange={handleInputChange}
            className="form-checkbox"
          />
          <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
            Учитывать инфляцию
          </span>
        </label>
      </div>

      {formData.includeInflation && (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label htmlFor="inflationRate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Ожидаемая инфляция (%)
              </label>
              <div className="relative">
                <input
                  type="text"
                  id="inflationRate"
                  name="inflationRate"
                  value={formData.inflationRate}
                  onChange={handleInputChange}
                  className={`form-input w-full ${errors.inflationRate ? 'input-error' : ''}`}
                  placeholder="Введите ставку инфляции"
                />
                <span className="absolute inset-y-0 right-3 flex items-center text-gray-500 pointer-events-none">
                  %
                </span>
              </div>
              {errors.inflationRate && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.inflationRate}
                </p>
              )}
            </div>

            <div className="h-full flex items-center">
              <p className="text-xs text-rose-600 dark:text-rose-400">
                Учет инфляции позволяет рассчитать реальную доходность портфеля. Целевой показатель инфляции ЦБ РФ - около 4%, но фактическая инфляция может отличаться.
              </p>
            </div>
          </div>

          <div className="mt-3 bg-rose-100 dark:bg-rose-900/30 p-3 rounded-lg text-sm text-rose-700 dark:text-rose-300">
            <p>
              <strong>Реальная доходность</strong> = (1 + номинальная доходность) / (1 + инфляция) - 1
            </p>
          </div>
        </>
      )}
    </div>
  );
};

export default InflationSection;